import React from 'react';
import { CheckIcon } from 'lucide-react';
import { pricing } from '../data/masterclass';
export function Pricing() {
  return <section aria-labelledby="pricing-heading" className="border-b border-ink-line bg-ink" id="pricing" data-id="element-60" data-mp="2aqj5pjswb8jo">
      <div className="mx-auto w-full max-w-5xl px-6 py-20 lg:py-24" data-id="element-61" data-mp="2oktkb8b6hmc0">
        <div className="text-center" data-id="element-62" data-mp="2jkxldnhc8l3b">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-63" data-mp="2jlyx7u66hbm3">
            Investment
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display text-4xl font-bold uppercase text-white sm:text-5xl" data-id="element-64" data-mp="1rsyei62nrxvw">
            Choose your seat
          </h2>
        </div>

        <div className="mt-12 grid items-stretch gap-6 sm:grid-cols-2" data-id="element-65" data-mp="20sv88m3wnmxt">
          {pricing.map(tier => <div key={tier.name} className={`flex flex-col rounded-2xl border p-8 ${tier.featured ? 'border-gold bg-gold/[0.06]' : 'border-ink-line bg-ink-soft'}`} data-id="element-66" data-mp="3h6bp2d1d6i5g">
              <div className="flex items-baseline justify-between gap-3" data-id="element-67" data-mp="4smf4stk67zu">
                <h3 className="font-display text-xl font-semibold uppercase text-white" data-id="element-68" data-mp="4uyvx2nkycbb">
                  {tier.name}
                </h3>
                {tier.featured && <span className="rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-69" data-mp="eqk097g4foo8">
                    Best value
                  </span>}
              </div>

              <div className="mt-6 flex items-end gap-2" data-id="element-70" data-mp="3i5pg08wf94xv">
                <span className="font-display text-6xl font-bold leading-none text-gold" data-id="element-71" data-mp="3n6d8z047nvuq">
                  {tier.price}
                </span>
                <span className="pb-1 text-sm text-white/50" data-id="element-72" data-mp="2uihdtzuaic02">{tier.unit}</span>
              </div>

              <p className="mt-4 leading-relaxed text-white/60" data-id="element-73" data-mp="2zhkkfopx4qa5">
                {tier.description}
              </p>

              <ul className="mb-8 mt-6 space-y-2.5" data-id="element-74" data-mp="2rgcv1t0ym9u7">
                {tier.perks.map(perk => <li key={perk} className="flex items-start gap-3 text-white/75" data-id="element-75" data-mp="2mibd5bf9sgkb">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-76" data-mp="316o948ecxzet" />
                    <span data-id="element-77" data-mp="2w83846ra7bpb">{perk}</span>
                  </li>)}
              </ul>

              <a href={tier.url} target="_blank" rel="noopener noreferrer" className={`mt-auto inline-flex items-center justify-center rounded-full px-7 py-4 text-sm font-semibold uppercase tracking-[0.16em] transition-[transform,background-color,color] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold ${tier.featured ? 'bg-gold text-ink hover:bg-gold-pale' : 'border border-gold text-gold hover:bg-gold hover:text-ink'}`} data-id="element-78" data-mp="28iinljfhc6dx">
                Pay {tier.price}
              </a>
            </div>)}
        </div>

        <p className="mt-8 text-center text-sm text-white/45" data-id="element-79" data-mp="3ng4upzma2kw4">
          Checkout is secure. After payment, register on Zoom to receive your join
          link.
        </p>
      </div>
    </section>;
}